import { useState } from 'react';

import { Formik } from 'formik';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';

import ErrorMessage from '../../Shared/Components/ErrorMessage';
import { error } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { serverErrorHandler, submitGatewayForm } from '../../Shared/utils/helper';
import Master from '../Layouts/Master';

const validationSchema = Yup.object().shape({
  amount: Yup.number()
    .typeError('مبلغ الزامی است')
    .required('مبلغ الزامی است')
    .min(10000, 'مبلغ نمیتواند کمتر از ۱۰٬۰۰۰ ریال باشد'),
});

const Wallet = () => {
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [serverErrors, setServerErrors] = useState({});

  const onSubmitForm = async (values, setSubmitting) => {
    setSubmitFormLoading(true);

    await useApi.post(
      '/wallet/increase',
      values,
      (res) => {
        if (submitGatewayForm(res.data?.data?.url)) {
          return;
        }
        error('آدرس درگاه پرداخت دریافت نشد');
        setSubmitFormLoading(false);
      },
      (err) => {
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error(`خطا در پرداخت`);
        }
        setSubmitFormLoading(false);
      },
    );
  };

  return (
    <Master title='افزایش کیف پول'>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            افزایش کیف پول
          </h1>
        </div>
        <Link
          to='/panel/matches/financial-management/wallet-history'
          className='d-flex flex-row btn btn-outline-secondary'
        >
          <span className='f-13'>تاریخچه کیف پول</span>
        </Link>
      </div>
      <Formik
        initialValues={{
          amount: '',
        }}
        onSubmit={(values, { setSubmitting }) => {
          onSubmitForm(values, setSubmitting);
        }}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className='row rounded mt-3'>
              <div className='col-12 col-md-8 offset-md-2'>
                <div className='form-group'>
                  <div className='d-flex flex-column mt-1 mx-2 my-3'>
                    <label>مبلغ (ریال)</label>
                    <input
                      name='amount'
                      value={values.amount}
                      onChange={handleChange}
                      min={10000}
                      placeholder='مثال: 10000'
                      type='number'
                      className='form-control'
                    />
                    <ErrorMessage
                      error={
                        errors?.amount ?? serverErrors?.amount
                      }
                    />
                  </div>
                </div>
              </div>

              <div className='col-12'>
                <div className='d-flex flex-row justify-content-center'>
                  <button className='btn btn-info f-14 px-5'>
                    {submitFormLoading ? (
                      <div
                        className='spinner-border spinner-border-sm text-white mb-1'
                        role='status'
                      ></div>
                    ) : (
                      'پرداخت'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </Master>
  );
};

export default Wallet;
